import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withProps, withHandlers, compose, lifecycle, branch, renderComponent } from 'recompose';
import { Spin } from 'antd';
import isInteger from 'lodash/isInteger';

import { Pressure as PressureAction } from '~/actions';
import { Content } from '~/containers/styles';
import { PressureFilters, PressureGraph as Graph } from '~/components';
import moment from '~/_moment';

import { FlexBox } from './style';

const Spiner = () => (
  <FlexBox direction="column">
    <Spin size="large" />
  </FlexBox>
);

const PressureGraph = ({
  pressure,
  profile,
  sensor,
  handleChangeDate,
  handleChangeStartTime,
  handleChangeEndTime,
  handleChangeSensor,
  handleChangeDateTime,
}) => {
  const {
    site_name: siteName,
    pressure: {
      enable: isPressureEnable,
      total: { end: totalSensor },
      head_water_sensor: waterLevelSensor,
    },
    firstRun,
  } = profile;
  return (
    <Content>
      <Helmet>
        <title>ระบบจำลองแรงดันภายในตัวเขื่อน</title>
      </Helmet>
      {isPressureEnable && (
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <PressureFilters
                showTimePicker
                siteName={siteName}
                dateFormat="YYYY-MM-DD"
                timeFormat="HH:mm"
                sensorValue={sensor}
                dateValue={pressure.date}
                startTimeValue={pressure.startTime}
                endTimeValue={pressure.endTime}
                isPressureloading={pressure.isloading}
                handleLoadData={handleChangeDateTime}
                handleChangeDate={handleChangeDate}
                handleChangeStartTime={handleChangeStartTime}
                handleChangeEndTime={handleChangeEndTime}
                handleChangeSensor={handleChangeSensor}
                disabledDate={moment(firstRun).subtract(1, 'days')}
                showSensorFilter
                waterLevelSensor={waterLevelSensor}
                totalSensor={totalSensor}
              />
              <Graph sensor={sensor} pressureData={pressure.data} />
            </div>
          </div>
        </div>
      )}
    </Content>
  );
};

export default compose(
  withProps(({ location }) => ({
    objURLSearchParams: new URLSearchParams(location.search),
  })),
  withProps(({ objURLSearchParams }) => {
    const requestSensor = objURLSearchParams.has('sensor')
      ? parseInt(objURLSearchParams.get('sensor'), 10)
      : 1;
    return {
      sensor: isInteger(requestSensor) ? requestSensor : 'waterLevel',
    };
  }),
  connect(
    ({ DamProfile, Pressure }) => ({
      profile: DamProfile,
      pressure: Pressure,
    }),
    {
      handleChangeDate: PressureAction.changeDate,
      handleChangeStartTime: PressureAction.changeStartTime,
      handleChangeEndTime: PressureAction.changeEndTime,
      loadPressure: PressureAction.loadPressureData,
      resetPressure: PressureAction.resetPressureData,
      setFilterDateTime: PressureAction.setFilterDateTime,
    },
    // (dispatch) => ({
    // handleChangeDate: (_, dateFormated) => dispatch(PressureAction.changeDate(dateFormated)),
    // handleChangeStartTime: (_, timeFormated) => dispatch(PressureAction.changeStartTime(timeFormated)),
    // handleChangeEndTime: (_, timeFormated) => dispatch(PressureAction.changeEndTime(timeFormated)),
    // setFilterDateTime: (filters) => dispatch(PressureAction.setFilterDateTime(filters)),
    // loadPressure: () => dispatch(PressureAction.loadPressureData()),
    // resetPressure: () => dispatch(PressureAction.resetPressureData()),
    // }),
  ),
  branch(({ profile }) => profile.site_name === 'Loading ...', renderComponent(Spiner)),
  withHandlers({
    handleChangeSensor: (props) => (sensor) => {
      const queryString = props.objURLSearchParams;
      queryString.set('sensor', sensor);
      props.history.push(`/pressure/history?${queryString.toString()}`);
    },
    handleChangeDateTime: (props) => () => {
      const queryString = props.objURLSearchParams;
      const { date, startTime, endTime } = props.pressure;

      if (queryString.has('sensor')) queryString.set('sensor', 1);

      queryString.set('date', date);
      queryString.set('start_time', startTime);
      queryString.set('end_time', endTime);

      props.history.push(`/pressure/history?${queryString.toString()}`);

      props.loadPressure();
    },
  }),
  lifecycle({
    componentDidMount() {
      const { objURLSearchParams } = this.props;
      this.props.setFilterDateTime({
        date: objURLSearchParams.has('date') ? objURLSearchParams.get('date') : null,
        startTime: objURLSearchParams.has('start_time')
          ? objURLSearchParams.get('start_time')
          : null,
        endTime: objURLSearchParams.has('end_time') ? objURLSearchParams.get('end_time') : null,
      });
      this.props.loadPressure();
    },
    componentWillUnmount() {
      this.props.resetPressure();
    },
  }),
)(PressureGraph);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/PressureGraph/PressureGraph.js